import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const authAPI = {
  register: (data) => apiClient.post('/auth/register', data),
  login: (data) => apiClient.post('/auth/login', data),
  getMe: () => apiClient.get('/auth/me'),
};

export const servicesAPI = {
  getAll: (params) => apiClient.get('/services', { params }),
  getById: (id) => apiClient.get(`/services/${id}`),
  create: (data) => apiClient.post('/services', data),
  update: (id, data) => apiClient.put(`/services/${id}`, data),
  delete: (id) => apiClient.delete(`/services/${id}`),
};

export const packagesAPI = {
  getAll: () => apiClient.get('/packages'),
  getById: (id) => apiClient.get(`/packages/${id}`),
  create: (data) => apiClient.post('/packages', data),
};

export const ordersAPI = {
  create: (data) => apiClient.post('/orders', data),
  getAll: () => apiClient.get('/orders'),
  getById: (id) => apiClient.get(`/orders/${id}`),
  updateStatus: (id, status) => apiClient.put(`/orders/${id}/status`, { status }),
  confirmPayment: (id) => apiClient.put(`/orders/${id}/confirm-payment`),
  uploadProofOfPayment: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient.post(`/orders/${id}/proof-of-payment`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  downloadProofOfPaymentURL: (id) =>
    `${apiClient.defaults.baseURL}/orders/${id}/proof-of-payment`,
};

export const testimonialsAPI = {
  getAll: () => apiClient.get('/testimonials'),
  create: (data) => apiClient.post('/testimonials', data),
  approve: (id) => apiClient.put(`/testimonials/${id}/approve`),
};

export const faqsAPI = {
  getAll: (params) => apiClient.get('/faqs', { params }),
  create: (data) => apiClient.post('/faqs', data),
};

export const adminAPI = {
  getStats: () => apiClient.get('/admin/stats'),
  getAllOrders: () => apiClient.get('/admin/orders'),
  getCustomers: () => apiClient.get('/admin/customers'),
  indexNowStatus: () => apiClient.get('/admin/indexnow-status'),
  indexNowPing: () => apiClient.post('/admin/indexnow-ping'),
};

export const paymentsAPI = {
  stripeCheckout: (orderId, originUrl) =>
    apiClient.post('/payments/stripe/checkout', { orderId, originUrl }),
  stripeStatus: (sessionId) => apiClient.get(`/payments/stripe/status/${sessionId}`),
  payfastCreate: (orderId, originUrl) =>
    apiClient.post('/payments/payfast/create', { orderId, originUrl }),
};

export const enquiriesAPI = {
  create: (data) => apiClient.post('/enquiries', data),
};

export default apiClient;
